<div *ngIf="showLoader" class="flash-loader">
  <div class="dot-flashing"></div>
</div>
